import { FC, useMemo } from "react";
import { PageHeader } from "@hostingbv/lib/src/components/content/PageHeader";
import { ContentContainer } from "@hostingbv/lib/src/components/content/ContentContainer";
import { useParams } from "react-router-dom";
import { config } from "../config";
import { useApiClient } from "@hostingbv/lib/src/api";
import { Breadcrumbs } from "@hostingbv/lib/src/components/content/Breadcrumbs";
import { Loading } from "@hostingbv/lib/src/components/Loading";
import { useFetchedResource } from "@hostingbv/lib/src/util/useFetchedResource";
import { useRefreshEffect } from "@hostingbv/lib/src/components/RefreshController";
import { MailDomain } from "@hostingbv/lib/src/api/partner/models/MailDomain";
import { EntityNotesButton } from "../components/EntityNotesButton";
import { faEnvelopeOpenText } from "@fortawesome/free-solid-svg-icons";
import { PageIconHeader } from "@hostingbv/lib/src/components/PageIconHeader";
import { ImapMailDomainDetails } from "../components/ImapMailDomainDetails";
import { TransactionalMailDomainDetails } from "../components/TransactionalMailDomainDetails";

export const MailDomainDetails: FC = () => {
  const { mailDomain: uuid } = useParams();
  const { partnerClient } = useApiClient(config);
  const { resource, reload } = useFetchedResource(() => partnerClient.getMailDomain(uuid ?? ""));
  const mailDomain: MailDomain | null = useMemo(() => (resource?.success === true ? resource.data : null), [resource]);
  useRefreshEffect(() => {
    reload();
  });

  return (
    <ContentContainer size={"lg"}>
      <PageIconHeader icon={faEnvelopeOpenText}>
        <Breadcrumbs
          currentPage={mailDomain?.displayName ?? "Mail domain"}
          crumbs={[{ label: "Mail Domains", href: "/mail" }]}
        />
        <PageHeader>
          {mailDomain === null ? (
            <span className={"block h-8 w-36 rounded-lg bg-slate-200 animate-pulse"}></span>
          ) : (
            mailDomain.displayName
          )}
          <EntityNotesButton entity={mailDomain} />
        </PageHeader>
      </PageIconHeader>

      <Loading loading={mailDomain === null}>
        {mailDomain && (
          <>
            {mailDomain.mailType === "imap_mail_domain" && <ImapMailDomainDetails mailDomain={mailDomain} />}
            {mailDomain.mailType === "transactional_mail_domain" && (
              <TransactionalMailDomainDetails mailDomain={mailDomain} />
            )}
          </>
        )}
      </Loading>
    </ContentContainer>
  );
};
